import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";
import AddAlignerMaterialDialog from "./AddAlignerMaterialDialog";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateAlignerMaterialDialog from "./UpdateAlignerMaterialDialog";
import {
  deleteAlignerMaterial,
  getAllAlignerMaterials,
} from "../../../../api/alignerMaterialsApi";
import ConfirmationDialog from "../../../../common/components/Dialog";
const AlignerMaterialsTable = ({
  theme,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const [openAddAlignerMaterial, setOpenAddAlignerMaterial] = useState(false);
  const [openUpdateAlignerMaterial, setOpenUpdatelignerMaterial] =
    useState(false);

  const [rows, setRows] = useState([]);
  const [currentAlignerMaterial, setCurrentAlignerMaterial] = useState({});
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  useEffect(() => {
    fetchAlignerMaterials();
  }, []);

  const fetchAlignerMaterials = async () => {
    const response = await getAllAlignerMaterials();

    setRows([...response]);
  };

  const handleOpenAddAlignerMaterial = () => {
    setOpenAddAlignerMaterial(true);
  };

  const handleCloseAddAlignerMaterial = () => {
    setOpenAddAlignerMaterial(false);
  };
  //Update
  const handleOpenUpdateAlignerMaterial = (event, params) => {
    event.stopPropagation();
    setCurrentAlignerMaterial({ ...params.row });
    setOpenUpdatelignerMaterial(true);
  };
  const handleCloseUpdateAlignerMaterial = () => {
    setOpenUpdatelignerMaterial(false);
  };

  const handleDeleteAlignerMaterial = async (id) => {
    await deleteAlignerMaterial({ Id: id });
    // if (response.data.error != null) {
    //   setErrorMessage(response.data.error.message);
    //   handleOpenSnackbar();
    // }
    await fetchAlignerMaterials();
  };

  const columns = [
    { field: "name", headerName: "Aligner Material", flex: 1 },
    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faPen} />}
            label="Update"
            onClick={(e) => handleOpenUpdateAlignerMaterial(e, params)}
          />,
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              console.log(params);
              setShowConfirmationDialog(true);
              setConfirmationSubmit(() => () => {
                handleDeleteAlignerMaterial(params.id);
                setShowConfirmationDialog(false);
              });
            }}
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Aligner Materials</StyledH2>
      <StyledButton onClick={handleOpenAddAlignerMaterial} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add aligner material
      </StyledButton>
      <AddAlignerMaterialDialog
        openAddAlignerMaterial={openAddAlignerMaterial}
        handleCloseAddAlignerMaterial={handleCloseAddAlignerMaterial}
        currentAlignerMaterial={currentAlignerMaterial}
        fetchAlignerMaterials={fetchAlignerMaterials}
        handleOpenAlert={handleOpenAlert}
        handleSetAlertMessage={handleSetAlertMessage}
      />
      <UpdateAlignerMaterialDialog
        openUpdateAlignerMaterial={openUpdateAlignerMaterial}
        handleCloseUpdateAlignerMaterial={handleCloseUpdateAlignerMaterial}
        currentAlignerMaterial={currentAlignerMaterial}
        fetchAlignerMaterials={fetchAlignerMaterials}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete aligner material?"}
      />
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default AlignerMaterialsTable;
